import axiosInstance, { handleResponse } from "./apiConfig";

export const getSupportTickets = async (params = {}) => {
  return handleResponse(axiosInstance.get("/SupportTickets", { params }));
};

export const createSupportTicketApi = async (payload) => {
  return handleResponse(axiosInstance.post("/SupportTickets", payload));
};

export const replySupportTicketApi = async (ticketId, payload) => {
  return handleResponse(
    axiosInstance.post(`/SupportTickets/${ticketId}/reply`, payload),
  );
};
